// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".out-of-stock{background-color:#fef0f0;font-size:13px;padding:10px 13px;border-radius:4px;color:#555;display:inline-block}.out-of-stock .out-of-stock__icon{font-size:16px;color:#000;font-weight:200}.out-of-stock--singlepage{color:#f08080;padding:6px 10px;margin-top:10px}.out-of-stock .out-of-stock__remove{text-decoration:underline;color:#f08080}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
